import { useRouter } from "next/router";
import Head from "next/head";
import Layout from "../../components/layout";
import EntryBlock from "../../components/affiliate-program/EntryBlock/EntryBlock";
import ProgramInfo from "../../components/affiliate-program/ProgramInfo/ProgramInfo";
import Roadmap from "../../components/affiliate-program/Roadmap/Roadmap";
import getFaqLocales from "../../locales/locales_faq";
import getCommonLocales from "../../locales/locales_common";
import BottomBanner from "../../components/affiliate-program/BottomBanner/BottomBanner";

export default function AffiliateProgram() {
	const { locale } = useRouter();
	const dictionary = { ...getFaqLocales(locale), ...getCommonLocales(locale) };

	let title = "Affiliate Partner Program – BgRem " + locale;
	let description = "Want to get paid for promoting BgRem? Apply to be an affiliate partner and you'll earn 30% recurring commission for every new customer you refer." + locale;
	let ogTitle = title;
	let ogDescription = description;

	const pageLink = "https://bgrem.ai/affiliates/";
	const seoImg = "https://bgrem.ai/seo/og-text.jpg";

	const getCanonicalLink = (locale) => {
		const enList = ["en", "ja", "ar"];

		if (enList.includes(locale)) {
			return `https://bgrem.ai/affiliates/`;
		} else {
			return `https://bgrem.ai/${locale}/affiliates/`;
		}
	};

	return (
		<Layout mainClassName="ai-main">
			<Head>
				<title>{title}</title>
				<meta name="description" content={description} />
				<meta property="og:type" content="website" />
				<meta property="og:title" content={ogTitle} />
				<meta property="og:description" content={ogDescription} />
				<meta property="og:url" content={pageLink} />
				<meta property="og:image" content={seoImg} />
				<meta property="og:site_name" content="bgrem" />
				<meta property="og:locale" content="en_US" />
				<meta property="og:section" content="Turn picture into painting with AI" />
				<meta name="twitter:title" content={ogTitle} />
				<meta name="twitter:description" content={ogDescription} />
				<meta property="twitter:card" content="summary_large_image" />
				<meta property="twitter:image:src" content={seoImg} />
				<meta name="twitter:image" content={seoImg} />
				<link rel="canonical" href={getCanonicalLink(locale)} />
			</Head>
			<EntryBlock dictionary={dictionary} />
			<ProgramInfo dictionary={dictionary} />
			<Roadmap dictionary={dictionary} />
			<BottomBanner dictionary={dictionary} />
		</Layout>
	);
}
